import { requester } from "../utils";

export const getAllPaymentGateways = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/payment-gateway/app`,
        method: "GET",
        withAuth: true,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log("get payment gateway error", err);
        reject(err);
      });
  });
};

export const getPaymentRedirect = (token) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/payment/redirect/${token}`,
        method: "GET",
        withAuth: true,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log("get payment redirect error", err);
        reject(err);
      });
  });
};

export const paymentRequest = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/payment/request`,
        method: "POST",
        withAuth: true,
        data
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log("payment request error", err);
        reject(err);
      });
  });
};